import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.DocumentComparison,
  title: 'Document Comparison',
  category: ComponentCategory.General,
};
